import { useLang } from "../context/LanguageContext";
import en from "../translations/en";
import fr from "../translations/fr";

export function useT() {
  const { lang } = useLang();
  return lang === "fr" ? fr : en;
}
